import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import Footer from './Footer/Footer';
import Header from './Header/Header';
import Menu from './Menu/Menu';
import './HomeLayout.scss';

const HomeLayout: FC = () => (
  <div className="HomeLayout">
    <Menu />
    <div className="HomeLayout__container">
      <Header />
      <div className="HomeLayoutBody">
        <div className="HomeLayoutBody__content">
          <Outlet />
        </div>
        <Footer />
      </div>
    </div>
  </div>
);

export default HomeLayout;
